import { render, staticRenderFns } from "./CatalogBanner.vue?vue&type=template&id=3db4c786&"
import script from "./CatalogBanner.js?vue&type=script&lang=js&"
export * from "./CatalogBanner.js?vue&type=script&lang=js&"
import style0 from "./CatalogBanner.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports